import React, { useState } from 'react';
import { Download, FileText, FileSpreadsheet } from 'lucide-react';
import RowActionsMenu from './RowActionsMenu';
import './export-button.css';

export default function ExportButton({ onExport, disabled = false, children = 'Export' }) {
  const [busy, setBusy] = useState(false);
  async function download(format) {
    setBusy(true);
    try { await onExport(format); }
    finally { setBusy(false); }
  }
  return <RowActionsMenu className="inv-export" label="Export format" disabled={disabled || busy} actions={[
    { label: 'PDF', icon: FileText, onClick: () => download('pdf') },
    { label: 'Excel', icon: FileSpreadsheet, onClick: () => download('xlsx') },
  ]}><Download size={14} />{busy ? 'Exporting...' : children}</RowActionsMenu>;
}
